module.exports = require("mdi-material-ui/Camera");